
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetooutstationtempo() {



    const cardData =
    {
        keyword: 'Pune to Outstation Tempo Traveller',
        heading: 'Mauli Cabs: Pune to Outstation Tempo Traveller',
        headingDescription: 'Mauli Cabs offers reliable Pune to outstation tempo traveller services, providing a comfortable and spacious ride for group travels, family trips, or corporate outings. Whether you’re heading for a family vacation, wedding, or any other group event, our well-maintained tempo travellers are perfect for long-distance journeys. With ample seating, air conditioning, and a smooth ride, we ensure your travel is stress-free and enjoyable. Our professional drivers ensure timely pick-ups, and we offer transparent pricing with no hidden charges.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located about 30 km from Pune, Sinhagad Fort is a favorite spot for trekking and offers panoramic views and a rich historical background."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganesh temples in Maharashtra, this temple is revered for its magnificent idol and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Parvati Hill",
        "description": "Parvati Hill offers a serene temple complex atop a hill with beautiful views of the city and is one of the oldest heritage sites in Pune."
    },
    {
        "title": "Osho Garden and Ashram",
        "description": "Located in Koregaon Park, this peaceful garden and spiritual center draws global visitors for meditation and relaxation in tranquil surroundings."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum showcases a fascinating collection of artifacts, including musical instruments, weaponry, and antiques, celebrating India’s cultural heritage."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Inspired by a Japanese design, this beautifully landscaped garden is perfect for calm walks and nature photography."
    },
    {
        "title": "Rajiv Gandhi Zoological Park",
        "description": "Also known as Katraj Zoo, this park houses various species of animals and a dedicated snake park, popular with families and kids."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, this ancient monument offers spiritual solace in the middle of the city."
    }
],

"services": [
    {
      "name": "Tempo Traveller on Rent in Pune",
      "description": "Rent a Tempo Traveller for your group travel needs in Pune. Whether it’s a local trip or an outstation journey, our well-maintained Tempo Travellers provide comfort and space for everyone."
    },
    {
      "name": "13 Seater Tempo Traveller on Rent in Pune",
      "description": "Book a 13-seater Tempo Traveller in Pune for small group travel. Perfect for family outings, corporate events, or trips with friends, offering ample space and comfort."
    },
    {
      "name": "17 Seater Tempo Traveller on Rent in Pune",
      "description": "Travel with a large group in a 17-seater Tempo Traveller. Ideal for family vacations, group tours, or corporate events, this vehicle ensures a smooth and comfortable ride."
    },
    {
      "name": "Book a Tempo Traveller in Pune",
      "description": "Easily book a Tempo Traveller in Pune for your local or outstation trips. Our fleet of well-maintained vehicles ensures comfort and timely arrivals."
    },
    {
      "name": "Book a Tempo Traveller in Pimpri Chinchwad",
      "description": "Hire a Tempo Traveller in Pimpri Chinchwad for any group travel needs. Whether it's a city tour or a trip to nearby places, we offer a range of vehicles for your convenience."
    },
    {
      "name": "Tempo Traveller on Rent in Viman Nagar",
      "description": "Rent a Tempo Traveller in Viman Nagar for local travel or outstation trips. Our vehicles are equipped with modern amenities to ensure a comfortable journey."
    },
    {
      "name": "Tempo Traveller on Rent in Kothrud",
      "description": "Rent a well-maintained Tempo Traveller in Kothrud for family trips, corporate events, or any group travel needs. Enjoy a spacious ride for a smooth journey."
    },
    {
      "name": "Mini Bus on Rent in Pune",
      "description": "Book a mini bus in Pune for large group travel. Whether you need it for a wedding, corporate event, or a sightseeing tour, our mini buses provide comfort and convenience."
    },
    {
      "name": "Mini Bus for Outstation in Pune",
      "description": "Rent a mini bus for outstation travel from Pune. Ideal for family vacations, corporate tours, or group trips to nearby destinations."
    },
    {
      "name": "17 Seater Tempo Traveller on Rent in Pune",
      "description": "Rent a 17-seater Tempo Traveller in Pune for your large group trips. Spacious and comfortable, this vehicle is perfect for family outings or corporate events."
    },
    {
      "name": "17 Seater Bus on Rent in Pune",
      "description": "For larger groups, rent a 17-seater bus in Pune. Whether it’s a local tour or an outstation trip, this bus provides ample seating and comfort for everyone."
    },
    {
      "name": "Tempo Traveller Hire in Pune",
      "description": "Hire a Tempo Traveller in Pune for your next trip. Offering a range of vehicle options, we cater to all your group travel needs, ensuring comfort and affordability."
    },
    {
      "name": "Luxury Tempo Traveller on Rent in Pune",
      "description": "Experience luxury travel with our premium Tempo Traveller on rent in Pune. Perfect for corporate trips, family vacations, or any event requiring comfort and style."
    },
    {
      "name": "17 Seater Tempo Traveller on Rent in Pune",
      "description": "Book a 17-seater Tempo Traveller for your next group outing in Pune. Spacious, comfortable, and ideal for both local and outstation trips."
    }
  ],
  "tableData": [
    ["Tempo Traveller on Rent in Pune", "13 Seater Tempo Traveller on Rent in Pune"],
    ["17 Seater Tempo Traveller on Rent in Pune", "Book a Tempo Traveller in Pune"],
    ["Book a Tempo Traveller in Pimpri Chinchwad", "Tempo Traveller on Rent in Viman Nagar"],
    ["Tempo Traveller on Rent in Kothrud", "Mini Bus on Rent in Pune"],
    ["Mini Bus for Outstation in Pune", "17 Seater Tempo Traveller on Rent in Pune"],
    ["17 Seater Bus on Rent in Pune", "Tempo Traveller Hire in Pune"],
    ["Luxury Tempo Traveller on Rent in Pune", "17 Seater Tempo Traveller on Rent in Pune"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Pune to Outstation Tempo Traveller",
        "WhyChoosedescription": "Mauli Cabs offers comfortable and spacious Tempo Travellers for your outstation trips from Pune. Whether you're going on a family vacation, a group tour, or a corporate event, our Tempo Travellers are perfect for long-distance journeys."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable for Group Travel",
        "WhyChoosedescription": "Our Tempo Travellers can accommodate large groups, providing ample seating and space for everyone. With comfortable seating, air conditioning, and plenty of luggage space, your outstation trip will be enjoyable and hassle-free."
    },
    {
        "WhyChooseheading": "Affordable Pricing for Outstation Travel",
        "WhyChoosedescription": "Mauli Cabs offers competitive and transparent pricing for outstation Tempo Traveller rentals. No hidden fees—just clear and affordable rates for your long-distance journey from Pune to your destination."
    },
    {
        "WhyChooseheading": "Experienced Drivers for a Safe Journey",
        "WhyChoosedescription": "Our professional and experienced drivers are well-versed in the routes and ensure a safe and smooth journey. They are committed to providing timely and secure transportation, making your outstation trip stress-free."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Whether it’s early in the morning or late at night, Mauli Cabs is available 24/7 for your outstation Tempo Traveller bookings. We cater to all travel schedules to ensure you reach your destination comfortably and on time."
    },
    {
        "WhyChooseheading": "Instant Booking and Real-Time Tracking",
        "WhyChoosedescription": "Booking your Tempo Traveller for an outstation trip is simple with our mobile app or website. Get instant booking confirmations and track your ride in real-time for added convenience and peace of mind."
    },
    {
        "WhyChooseheading": "Safe, Sanitized, and Secure Vehicles",
        "WhyChoosedescription": "We prioritize your safety. All our Tempo Travellers are sanitized regularly, and our drivers follow strict hygiene and safety protocols to ensure you have a clean and secure travel experience on your outstation trip."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Pay for your Tempo Traveller rental using various payment methods such as UPI, debit/credit cards, mobile wallets, or cash, making the booking process convenient and easy."
    }
]

















    }

    const faqData = [
        {
            question: 'How can I book a Tempo Traveller for an outstation trip from Pune?',
            answer: 'Booking a Tempo Traveller for an outstation trip from Pune is easy. Simply visit the Mauli Cabs website or mobile app, select "Tempo Traveller" from the vehicle options, enter your travel details (pickup and destination), and confirm your booking. Our customer support team is available to assist you at any time.',
        },
        {
            question: 'What is the seating capacity of the Tempo Traveller for outstation trips?',
            answer: 'The Tempo Traveller is available in different seating capacities, ranging from 12 to 17 seats. It is a perfect choice for large groups, family vacations, or corporate travel, ensuring ample space for passengers and luggage.',
        },
        {
            question: 'Is the fare for the Tempo Traveller fixed for outstation trips?',
            answer: 'Yes, the fare for the Tempo Traveller on outstation trips is fixed. The price includes fuel, driver charges, tolls, taxes, and other necessary fees. The total fare will be displayed before you confirm the booking, with no hidden charges.',
        },
        {
            question: 'Can I rent a Tempo Traveller for a round trip from Pune to an outstation?',
            answer: 'Yes, you can rent a Tempo Traveller for both one-way or round-trip outstation travel from Pune. For a round-trip, the return journey is typically discounted, making it more economical for long-distance travel.',
        },
        {
            question: 'Is the Tempo Traveller available 24/7 for outstation trips from Pune?',
            answer: 'Yes, Mauli Cabs offers Tempo Traveller services 24/7 for outstation trips from Pune. Whether it’s a daytime or nighttime journey, you can book a Tempo Traveller anytime according to your travel schedule.',
        },
        {
            question: 'Can I carry extra luggage in the Tempo Traveller for an outstation trip?',
            answer: 'Yes, the Tempo Traveller offers ample space for luggage. It is designed to accommodate both passengers and luggage comfortably, so you can easily carry extra or bulky items during your outstation journey.',
        },
        {
            question: 'What are the benefits of renting a Tempo Traveller for an outstation trip from Pune?',
            answer: 'The Tempo Traveller offers comfort, space, and flexibility for outstation trips. With features like air conditioning, comfortable seating, and enough space for luggage, it ensures a pleasant journey for groups, families, or corporate trips. It’s also a more affordable and convenient option compared to individual cars for large groups.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rohit Agrawal",
            position: "Business Owner",
            text: "We rented a Tempo Traveller for an outstation trip from Pune. The vehicle was very comfortable and spacious for our group of 15. The driver was professional, and the trip went smoothly. Highly recommend Mauli Cabs for group travel!",
            image: "/img/testimonial/testimonial-thumb-1-103.png",
        },
        {
            name: "Ms. Priya Sharma",
            position: "Wedding Planner",
            text: "I rented a Tempo Traveller for a family trip to a nearby destination from Pune. The vehicle was comfortable, and the driver was polite and accommodating. It was the perfect choice for our large group, and the service was top-notch!",
            image: "/img/testimonial/testimonial-thumb-1-104.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Outstation Tempo Traveller",
        "description": "Rent 13 to 17 seater tempo travellers in Pune for outstation trips. Available for local tours, corporate events, weddings, and more. Book your luxury mini bus or tempo traveller now.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "300"
        },
        "offers": {
          "@type": "Offer",
          "url": "https://www.maulicabs.com/pune-to-outstation-tempo-traveller",
          "priceCurrency": "INR",
          "price": "25",
          "priceValidUntil": "2025-12-31"
        }
      };
      
     

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Outstation Tempo Traveller | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Rent 13 to 17 seater tempo travellers in Pune for outstation trips. Ideal for family tours, corporate events, weddings, and local tours. Book luxury mini buses with Mauli Cabs."
        />
        <meta
          name="keywords"
          content="Tempo Traveller on rent in Pune, 13 seater tempo traveller, 17 seater tempo traveller, book tempo traveller in Pune, outstation tempo traveller, tempo traveller for weddings, tempo traveller for corporate events, mini bus on rent in Pune"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      



            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/135.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetooutstationtempo;